
export interface Motonave {
  id: number,
  name: string,
  isActive: boolean,
}
